import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { FuseConfig, FuseConfigService } from "@fuse/services/config";
import { WINDOW } from "./app.config";

@Injectable({
  providedIn: 'root'
})


export class ConfigService {

  constructor(@Inject(WINDOW) private window: Window, private http: HttpClient, private fuseConfig: FuseConfigService) { }

  loadConfig() {
    const tenantConfig = this.resolveTenantConfig();

    this.fuseConfig.config = {layout: 'modern'};
    this.fuseConfig.config = {scheme: 'light'};
    this.fuseConfig.config = {theme: tenantConfig.theme};
    this.fuseConfig.config = {settings: tenantConfig};
    
    // if (environment.tenantDomainConfig[host].ga_tracking_id) {
    //   this.loadGoogleAnalytics(environment.tenantDomainConfig[host].ga_tracking_id);
    // }

    // if (environment.tenantDomainConfig[host!].gm_api_key) {
    //   this.loadGoogleMaps(environment.tenantDomainConfig[host].gm_api_key);
    // }

    this.loadTitle(tenantConfig.pageTitle);

    if (tenantConfig.favIcon) {
      this.loadFavIcon(tenantConfig.favIcon);
    }
  }

  private loadTitle(pageTitle: string) {
    document.title = pageTitle;
  }

  private loadFavIcon(favIconUrl: string): void {
    let favIcon = document.querySelector<HTMLLinkElement>('link[rel="icon"]');

    if (!favIcon) {
      favIcon = document.createElement('link');
      favIcon.setAttribute('rel', 'icon');
      favIcon.setAttribute('type', 'image/x-icon');
      document.head.appendChild(favIcon);
    }

    favIcon.setAttribute('href', `${favIconUrl}`);
  }

  private loadGoogleMaps(API_KEY: string): void {

    let gmScript = document.createElement('script');

    gmScript.setAttribute('async', 'true');
    gmScript.setAttribute('src', `https://maps.googleapis.com/maps/api/js?key=${API_KEY}&libraries=places`);

    document.documentElement.firstChild?.appendChild(gmScript);
  }

  private loadGoogleAnalytics(trackingID: string): void {

    let gaScript = document.createElement('script');
    gaScript.setAttribute('async', 'true');
    gaScript.setAttribute('src', `https://www.googletagmanager.com/gtag/js?id=${trackingID}`);

    let gaScript2 = document.createElement('script');
    gaScript2.innerText = `window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag(\'js\', new Date());gtag(\'config\', \'${trackingID}\');`;

    document.documentElement.firstChild.appendChild(gaScript);
    document.documentElement.firstChild.appendChild(gaScript2);
  }

  private getHostname(): string {
    const hostname = this.window.location.hostname;

    if (hostname.startsWith('localhost') || hostname === '127.0.0.1') {
      return environment.tenantDomain;
    }

    return hostname;
  }

  private resolveTenantConfig() {
    const host = this.getHostname();
    return environment.tenantDomainConfig[host] ?? environment.tenantDomainConfig[environment.tenantDomain];
  }

}


export interface Config {
  apiUrl: string;
  theme: string;
  layout: string;
  scheme: string;
  hostname: string;
  settings: any;
  redirectURLAfterCommPrefUpdate: string;
}
